import { modalUi } from './modalUi';

export function modal() {
  if (document.querySelector('.js-modal')) {
    modalUi();
  }
}
